import React from "react";
import { findAllCompetencyGroupEvent } from "../../_events/competency-group/find.event";
import { alertError } from "../../_utils/alerts";

export const useCompetencyGroupAll = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllCompetencyGroupEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}